"use client";
import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import NavbarMobileBanners from "./NavbarMobileBanners";
import { usePathname } from "next/navigation";
import { useMediaQuery, useTheme } from "@mui/system";
import GetAppNotification from "../get-app/GetAppNotification";

export const NavbarWraper = () => {
  const [reloadScrollFlag, setReloadScrollFlag] = useState(false);
  const [reloadNavBackground, setReloadNavBackground] = useState();
  const [visible, setVisible] = useState(true);
  const [reloadSearchPositionFlag, setReloadSearchPositionFlag] =
    useState(false);
  const pathname = usePathname();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (pathname !== "/") {
      setReloadScrollFlag(true);
      setReloadSearchPositionFlag(true);
    }
  }, [pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {pathname == "/" && isSmallScreen && (
        <GetAppNotification visible={visible} setVisible={setVisible} />
      )}
      {pathname == "/" && isSmallScreen && (
        <NavbarMobileBanners
          setReloadScrollFlag={setReloadScrollFlag}
          setReloadSearchPositionFlag={setReloadSearchPositionFlag}
          reloadNavBackground={setReloadNavBackground}
          visible={visible}
        />
      )}
      <Navbar
        setReloadCartService={() => {}}
        reloadScrollFlag={reloadScrollFlag}
        reloadSearchPositionFlag={reloadSearchPositionFlag}
        reloadNavBackground={reloadNavBackground}
        visible={visible}
      />
    </>
  );
};
